import { createContext } from "react";

const StudentAssignmentContext = createContext();

export default StudentAssignmentContext;